import Base from './Base';

class Comments extends Base {
    getForCommentable(
        commentableKey: string,
        query = null,
        page = null,
        count = null,
        opts = null,
    ) {
        return this.getJSONWithSession(
            `/comments/${commentableKey}`,
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        );
    }

    createForCommentable(commentableKey: string, data, opts = null) {
        return this.postJSONWithSession(`/comments/${commentableKey}`, data, opts);
    }

    update(id: string, data, opts = null) {
        return this.postJSONWithSession<Comment>(`/comments/${id}`, data, opts);
    }

    react(commentId: string, reaction: string, opts = null) {
        return this.postJSONWithSession<Comment>(
            `/comments/${commentId}/reactions`,
            { reaction },
            opts,
        );
    }

    destroy(commentId: string, opts = null) {
        return this.postJSONWithSession(`/comments/${commentId}`, { _method: 'DELETE' }, opts);
    }

    restore(commentId: string, opts = null) {
        return this.postJSONWithSession<Comment>(`/comments/${commentId}/restore`, {}, opts);
    }

    block(commentId: string, blocked: boolean, opts = null) {
        return this.postJSONWithSession(
            `/comments/${commentId}/block`,
            {
                blocked,
            },
            opts,
        );
    }

    pin(commentId: string, pinned: boolean, opts = null) {
        return this.postJSONWithSession<Comment>(
            `/comments/${commentId}/pin`,
            {
                pinned,
            },
            opts,
        );
    }
}

export default Comments;
